"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.clearStagedChanges = exports.replaceStagedLanguageSettingsChanges = exports.getStageUpdateLanguageSetting = exports.StagingActionTypes = void 0;

var _namespacedKeyMirror = _interopRequireDefault(require("settings-ui-lib/utils/namespacedKeyMirror"));

var _fluxActions = require("flux-actions");

var StagingActionTypes = (0, _namespacedKeyMirror.default)({
  STAGE_UPDATE_LANGUAGE_SETTING: null,
  REPLACE_STAGED_LANGUAGE_SETTINGS: null,
  CLEAR_STAGED_CHANGES: null,
  SAVE_STAGED_CHANGES: null
}, 'domains');
exports.StagingActionTypes = StagingActionTypes;

var getStageUpdateLanguageSetting = function getStageUpdateLanguageSetting(setting) {
  return (0, _fluxActions.createAction)(StagingActionTypes.STAGE_UPDATE_LANGUAGE_SETTING, function (domain, value) {
    return {
      domain: domain,
      setting: setting,
      value: value
    };
  });
};

exports.getStageUpdateLanguageSetting = getStageUpdateLanguageSetting;
var replaceStagedLanguageSettingsChanges = (0, _fluxActions.createAction)(StagingActionTypes.REPLACE_STAGED_LANGUAGE_SETTINGS, function (settings) {
  return settings;
});
exports.replaceStagedLanguageSettingsChanges = replaceStagedLanguageSettingsChanges;
var clearStagedChanges = (0, _fluxActions.createAction)(StagingActionTypes.CLEAR_STAGED_CHANGES);
exports.clearStagedChanges = clearStagedChanges;